import { RewardsComponentsActions } from './actions'
import { RewardsComponentsActivityFeed } from './activityFeed'
import { RewardsComponentsBalanceHeader } from './balanceHeader'
import { BalanceHeaderCard } from './balanceHeaderCard'

export const RewardsComponents = {
  Actions: RewardsComponentsActions,
  ActivityFeed: RewardsComponentsActivityFeed,
  BalanceHeader: RewardsComponentsBalanceHeader,
  BalanceHeaderCard: BalanceHeaderCard,
}
